import React from "react";
import { Colors } from "../../utils/variables";
import "./skillsClinicsSection.scss";

export default function SkillsClinicsSection({ data, variant = "cards", showSectionHeader = true, showRegisterButton = true, cardBackgroundColor, showImage = true }) {
  if (!data || !data.clinics || !data.clinics.length) return null;

  const { title, price, description, clinics } = data;

  const isHorizontal = variant === "horizontal";
  const isCondensed = variant === "condensed";
  const cardClassName = "skills-clinic-card primary-background" + (isCondensed ? " skills-clinic-card--condensed" : "");
  const baseCardStyle = isHorizontal
    ? { borderRadius: 10, padding: 30, height: "100%", backgroundImage: 'url("/images/topo-texture.png")', backgroundSize: "cover", backgroundPosition: "center" }
    : { borderRadius: 10, padding: 30, height: "100%" };
  const cardStyle = cardBackgroundColor
    ? { ...baseCardStyle, backgroundColor: cardBackgroundColor, textAlign: "center" }
    : baseCardStyle;
  if (isCondensed) {
    cardStyle.padding = 16;
  }

  const truncateDescription = (text, maxLength = 120) =>
    text.length <= maxLength ? text : text.slice(0, maxLength).trim() + "…";

  const renderCard = (clinic) => {
    const cardContent = (
      <div className={cardClassName} style={cardStyle}>
        {isCondensed ? (
          <>
            <h3 className="white skills-clinic-card__title" style={{ textDecoration: "none", fontSize: "1rem", marginBottom: "0.25rem" }}>{clinic.title}</h3>
            <p className="white skills-clinic-card__date" style={{ textDecoration: "none", fontSize: "0.85rem", opacity: 0.9, marginBottom: "0.5rem" }}>{clinic.dateTime}</p>
            <p className="white subheading skills-clinic-card__desc">{isCondensed ? truncateDescription(clinic.description) : clinic.description}</p>
            {showRegisterButton && clinic.registerUrl && clinic.buttonText && (
              <div style={{ marginTop: "auto", paddingTop: 8, backgroundColor: "rgba(255, 255, 255, 0.1)", color: Colors.white, fontSize: "0.85rem", padding: "6px 12px" }} className="button">
                {clinic.buttonText}
              </div>
            )}
          </>
        ) : (
          <>
            <h2 className="white" style={{ textDecoration: "none" }}>{clinic.title}</h2>
            <h4 className="white" style={{ textDecoration: "none" }}>{clinic.dateTime}</h4>
            <p className="white subheading">{clinic.description}</p>
            {clinic.footerNote && (
              <p className="white"><b>{clinic.footerNote}</b></p>
            )}
            {!isHorizontal && showRegisterButton && clinic.registerUrl && clinic.buttonText && (
              <div style={{ marginBottom: 20, backgroundColor: Colors.tertiary, color: Colors.white }} className="button">
                {clinic.buttonText}
              </div>
            )}
          </>
        )}
      </div>
    );

    if (clinic.registerUrl && showRegisterButton) {
      return (
        <a className="full-height skills-clinic-card-link" style={{ textDecoration: "none" }} target="_blank" rel="noopener noreferrer" href={clinic.registerUrl}>
          {cardContent}
        </a>
      );
    }
    return (
      <div className="full-height">
        {cardContent}
      </div>
    );
  };

  const sectionHeader = showSectionHeader && (
    <>
      <h1 className="white">{title}</h1>
      <h4 className="white">{price}</h4>
      {showImage && <img src="/images/clinics-hero.jpg" alt="Event Kicker" className="full-width" />}
      <p className="subheading white">{description}</p>
    </>
  );

  if (variant === "horizontal") {
    return (
      <div className="skills-clinics-section skills-clinics-horizontal">
        <div className="skills-clinics-horizontal-inner medium-max-width-container">
          <div className="skills-clinics-horizontal-header centered-text">
            {sectionHeader}
          </div>
          <div className="skills-clinics-scroll-wrapper">
            <div className="skills-clinics-scroll-track">
              {clinics.map((clinic) => (
                <div key={clinic.id} className="skills-clinic-scroll-card">
                  {renderCard(clinic)}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  const isOddCount = clinics.length % 2 === 1;
  const getCardColumnClass = (index) =>
    isOddCount && index === clinics.length - 1
      ? "small-12 medium-12 tiny-padding"
      : "small-12 medium-6 tiny-padding";

  const getCondensedColumnClass = () => "small-12 medium-4 tiny-padding";

  if (variant === "condensed") {
    return (
      <div className="skills-clinics-section skills-clinics-condensed">
        <div className="max-width-container" style={{ maxWidth: "none", padding: 0 }}>
          {sectionHeader}
          <div className="row skills-clinics-cards-row" style={{ alignItems: "stretch" }}>
            {clinics.map((clinic) => (
              <div key={clinic.id} className={getCondensedColumnClass()}>
                {renderCard(clinic)}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (variant === "page") {
    return (
      <div className="skills-clinics-section skills-clinics-page">
        <div className="max-width-container" style={{ maxWidth: 1200 }}>
          {sectionHeader}
          <div className="row skills-clinics-cards-row" style={{ alignItems: "stretch" }}>
            {clinics.map((clinic, index) => (
              <div key={clinic.id} className={getCardColumnClass(index)}>
                {renderCard(clinic)}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // default: cards (e.g. register page, event page)
  const sectionPadding = cardBackgroundColor ? { paddingTop: "2.5rem", paddingBottom: "2.5rem" } : {};
  const centeredHeader =
    cardBackgroundColor && sectionHeader ? (
      <div className="centered-text" style={{ marginBottom: "1.5rem" }}>
        {sectionHeader}
      </div>
    ) : (
      sectionHeader
    );

  return (
    <div className="skills-clinics-section skills-clinics-cards">
      <div className="max-width-container" style={{ maxWidth: 1200, ...sectionPadding }}>
        {centeredHeader}
        <div className="row" style={{ alignItems: "stretch" }}>
          {clinics.map((clinic, index) => (
            <div key={clinic.id} className={getCardColumnClass(index)}>
              {renderCard(clinic)}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
